import { FETCH_PERSON_SUMMARY } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_PERSON_SUMMARY);
export default addReducer;
